import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { SubscribeService } from '../../../services/subscribe.service';

interface FeedItem {
  id: number;
  type: 'article' | 'status' | 'comment' | 'topic' | 'discussion';
  subscriptions?: {
    subscribed_by_current_user?: boolean;
  };
  current_user_permissions?: {
    subscribe?: boolean;
  };
}

@Component({
  selector: 'ut-community-feed-item-subscribe',
  templateUrl: './community-feed-item-subscribe.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommunityFeedItemSubscribeComponent implements OnInit {
  @Input() item!: FeedItem;

  processing = false;
  title = '';

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject('AlertService') private AlertService: any,
    private SubscribeService: SubscribeService,
    @Inject('LightTesterErrorService') private LightTesterErrorService: any,
  ) {}

  ngOnInit(): void {
    this.processing = false;
    this.title = this.item.subscriptions?.subscribed_by_current_user ? 'Unsubscribe' : 'Subscribe';
  }

  get hasSubscribePermission(): boolean {
    return this.item?.current_user_permissions?.subscribe === true;
  }

  subscribeToggle(): void {
    if (this.LightTesterErrorService.show()) return;

    if (!this.processing) {
      this.processing = true;
      this.cdr.markForCheck();

      if (this.item.subscriptions === undefined || !this.item.subscriptions.subscribed_by_current_user) {
        this.SubscribeService.subscribe(this.item).then(
          (res: any) => this.successCallback(res),
          () => this.errorCallback(),
        );
      } else {
        this.SubscribeService.unsubscribe(this.item).then(
          (res: any) => this.successCallback(res),
          () => this.errorCallback(),
        );
      }
    }
  }

  private successCallback(res: any): void {
    this.item.subscriptions = res.data.subscriptions;
    if (this.item.subscriptions.subscribed_by_current_user) {
      this.AlertService.add(`You successfully subscribed to this ${this.item.type}`);
      this.title = 'Unsubscribe';
    } else {
      this.AlertService.add(`You successfully unsubscribed from this ${this.item.type}`);
      this.title = 'Subscribe';
    }
    this.processing = false;
    this.cdr.markForCheck();
  }

  private errorCallback(): void {
    this.processing = false;
    this.AlertService.add('Request failed', 'danger');
    this.cdr.markForCheck();
  }
}
